import React from 'react';

const WarningIcon = (props) => (
    <svg version="1.1" fill={props.fill} xmlns="http://www.w3.org/2000/svg" width={props.width} height={props.height} viewBox="0 0 32 32">
        <title>Icon-Alert</title>
        <desc>Created with Sketch.</desc>
        <g id="Icon-Alert">
            <path id="Fill-1" className="st0" d="M10.9,12.9c0,0.1,0,0.1,0.1,0.2c0.1,0.1,0.1,0.1,0.2,0.1h1.3c0.1,0,0.2,0,0.2-0.1
		c0.1-0.1,0.1-0.1,0.1-0.2L13,9.2C13,9,13,9,12.9,8.9c-0.1-0.1-0.1-0.1-0.2-0.1H11c-0.1,0-0.2,0-0.2,0.1C10.7,9,10.6,9,10.6,9.2
		L10.9,12.9z M11,14c-0.2,0.2-0.4,0.5-0.4,0.9c0,0.3,0.1,0.6,0.4,0.9c0.2,0.2,0.5,0.4,0.9,0.4c0.3,0,0.6-0.1,0.9-0.4
		c0.2-0.2,0.4-0.5,0.4-0.9c0-0.3-0.1-0.6-0.4-0.9c-0.2-0.2-0.5-0.4-0.9-0.4C11.5,13.6,11.2,13.8,11,14z M19.7,16.9
		c-0.1,0.3-0.2,0.6-0.4,0.8C19,17.8,18.7,18,18.4,18H5.3c-0.3,0-0.6-0.1-0.8-0.3c-0.2-0.2-0.4-0.5-0.4-0.8C4,16.6,4,16.3,4.2,16
		l6.5-11.3c0.2-0.3,0.4-0.5,0.7-0.6C11.7,4,12,4,12.3,4.1c0.3,0.1,0.5,0.3,0.7,0.6L19.5,16C19.7,16.3,19.7,16.6,19.7,16.9z"/>
        </g>
    </svg>
);

export default WarningIcon;